import { createGlobalStyle } from "styled-components"

export const RemirrorPreviewStyles = createGlobalStyle`
  .remirror-preview-container {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.5;
    color: #333;
    max-width: 100%;
    overflow-x: visible!important; // Si cambian esto a otro valor que no sea visible dejara de funcionar los elementos que estan sticky como los thumbnails del PDF o su barra de controles.
  }

  .remirror-preview-container .remirror-editor-wrapper {
    padding: 0;
    border: none;
    box-shadow: none;
  }

  .remirror-preview-container .remirror-editor {
    outline: none !important;
    padding: 0;
  }

  /* Estilos para los videos */
  .remirror-preview-container .remirror-video-wrapper {
    position: relative;
    border-radius: 8px;
    display: block;
    overflow: visible;
    min-width: 240px;
    min-height: 135px;
    max-width: 100%;
    margin: 1.5rem 0;
    box-sizing: border-box;
  }

  .remirror-preview-container .remirror-video-wrapper-container {
    border-radius: 8px;
    overflow: hidden;
    max-width: 100%;
  }


  .remirror-preview-container .remirror-video-wrapper video {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    border-radius: 6px;
  }

  /* Estilos para las imágenes */
  .remirror-preview-container .custom-image-wrapper {
    display: block;
    margin: 1.5rem 0;
    max-width: 100%;
  }

  .remirror-preview-container .custom-image-wrapper img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
  }

  /* Estilos para los encabezados */
  .remirror-preview-container h1 {
    font-size: 2rem;
    font-weight: bold;
    margin: 0;
  }

  .remirror-preview-container h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }

  .remirror-preview-container h3 {
    font-size: 1.5rem;
    margin: 0;
  }

  /* Estilos para los enlaces */
  .remirror-preview-container a {
    color: #7c3aed;
    text-decoration: none;
  }

  .remirror-preview-container a:hover {
    text-decoration: underline;
  }

  /* Estilos para los párrafos */
  .remirror-preview-container p {
    margin: 0;
  }

  /* Estilos para el texto con formato */
  .remirror-preview-container strong {
    font-weight: 600;
  }

  .remirror-preview-container em {
    font-style: italic;
  }

  .remirror-preview-container s {
    text-decoration: line-through;
  }

  /* Mensaje de error */
  .remirror-preview-error {
    color: #e53e3e;
    padding: 1rem;
    border: 1px solid #e53e3e;
    border-radius: 8px;
    background-color: #fff5f5;
  }

  .remirror-preview-container p {
    margin: 0 0 0 0 !important; /* o 0.5em para menos espacio */
  }

  /* Estilos para los PDFs */
  .remirror-preview-container .remirror-pdf-wrapper {
    position: relative;
    width: 100%;
    margin: 1.5rem 0;
  }

  /* Bloquear solo las páginas del PDF y thumbnails, no los controles */
  // .remirror-preview-container .remirror-pdf-wrapper.download-blocked .react-pdf__Page {
  //   user-select: none;
  //   -webkit-user-select: none;
  //   -moz-user-select: none;
  //   -ms-user-select: none;
  //   pointer-events: none;
  //   -webkit-user-drag: none;
  //   -khtml-user-drag: none;
  //   -moz-user-drag: none;
  //   -o-user-drag: none;
  //   user-drag: none;
  //   cursor: not-allowed;
  // }

  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .react-pdf__Page canvas {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  /* Bloquear thumbnails específicamente */
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .thumbnail .react-pdf__Page {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    cursor: not-allowed;
  }

  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .thumbnail .react-pdf__Page canvas {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }

  /* Mantener los controles interactivos */
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .Toolbar,
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .Tools,
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .Button,
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .Pagination,
  .remirror-preview-container .remirror-pdf-wrapper.download-blocked .Input {
    pointer-events: auto;
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .remirror-preview-container .remirror-video-wrapper > div {
      max-width: 100%!important;
      height: auto!important;
    }
  }
`